<template>
  <main class="reward--ideas--container">
    <nav-title :color="true" :title="'Rewards'" custom-class="nav__title" />
    <header class="p-3 mt-2 d-flex justify-content-between">
      <div class="rewards__icon">
        <span class="material-icons align-middle smaller">
          card_giftcard
        </span>
        <small class="text-uppercase font-weight-bold mx-1">
          Rewards
        </small>
      </div>
      <div class="rewards--select-child">
        <radio-select :data="childrens" :selectedValue="childSelected" @change="setChildValue" />
      </div>
    </header>
    <section class="p-3 rewards--ideas">
      <h3 class="text-main2 border-bottom mb-3">Reward ideas</h3>
      <rewards-list-ideas @OnSelectRewards="handleSelectRewards" />
    </section>
    <button-float custom-css="reward-btn-container">
      <button class="reward-btn" @click="handleSaveRewards">
        <div class="reward-btn-icon">
          <span class="material-icons align-middle">
            card_giftcard
          </span>
        </div>
        <span class="ml-4">Save reward</span>
      </button>
    </button-float>
  </main>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import { ButtonFloat } from '@/components/general/buttons';
import NavTitle from '@/components/general/navTitle.vue';
import RadioSelect from '@/components/general/radioSelect/radioSelect.vue';
import RewardsListIdeas from '@/components/rewards/RewardsListIdeas.vue';

export default {
  components: {
    NavTitle,
    RadioSelect,
    RewardsListIdeas,
    ButtonFloat,
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const userId = store.getters['user/getUserId'];
      await Promise.all([
        store.dispatch('parent/FetchChildrenData', userId),
        store.dispatch('rewards/fetchRewardsIdeas'),
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      next();
    }
  },
  data() {
    return {
      childSelected: 0,
      rewardsSelected: [],
    };
  },
  mounted() {
    this.childSelected = localStorage.getItem('rewardChildId') || this.childrens[0].value || 0;
  },
  computed: {
    ...mapGetters('parent', ['getChildrenData']),
    ...mapGetters('user', ['getUserId']),
    childrens() {
      return this.getChildrenData
        .filter((child) => child.child_enabled)
        .map((child) => {
          return {
            value: child.id,
            text: child.name,
            image: child.avatar && child.avatar.image ? child.avatar.image : null,
          };
        });
    },
  },
  methods: {
    ...mapActions('rewards', ['CreateReward']),
    setChildValue(childSelected) {
      this.childSelected = childSelected;
      localStorage.setItem('rewardChildId', this.childSelected);
    },
    handleSelectRewards(rewardsSelected) {
      this.rewardsSelected = rewardsSelected;
    },
    adapRewardsToSend(reward) {
      const { id, reward_type, stars_required, name } = reward;
      const formData = new FormData();
      formData.append('child', this.childSelected);
      formData.append('parent', this.getUserId);
      formData.append('bank_reward_id', id);
      formData.append('reward_type', reward_type);
      formData.append('stars_required', stars_required);
      formData.append('name', name);
      return formData;
    },
    async handleSaveRewards() {
      try {
        const rewardsToCreate = this.rewardsSelected.map((reward) =>
          this.adapRewardsToSend(reward),
        );
        const rewardsPromises = rewardsToCreate.map((reward) => this.CreateReward(reward));
        const response = await Promise.all(rewardsPromises);
        if (response[0].includes('error')) throw new Error('Problem trying create the rewards');
        this.$router.push({ name: 'Rewards' });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style lang="scss">
.reward--ideas--container {
  .nav__title {
    section {
      gap: 1rem;
      text-align: left !important;
    }
  }
  .rewards__icon {
    color: var(--color-main);
  }

  .reward-btn {
    display: flex;
    padding: 1rem 3rem;
    align-items: center;
    border: transparent;
    border-radius: 30px;
    background-color: #f49d94;
    box-shadow: 0px 3px 6px #00000029;
    color: white;
    outline: none;

    &-container {
      bottom: 24px;
      right: 16px;
    }

    &-icon {
      padding: 1rem;
      background: #ffd1d4;
      border-radius: 50%;
      position: absolute;
      left: -3px;
      box-shadow: 0px 3px 6px #00000029;
      & span {
        color: #d79b95;
        font-size: 1.5rem;
      }
    }
  }
}
</style>
